import Details from '@/components/Details/Details';
import { ROUTE_BOOKING_PAGE } from '@/constants/routes';
import IEventType from '@/types/IEventType';
import { Accordion } from '@chakra-ui/react';
import { useTranslation } from 'react-i18next';
import { FcShare } from 'react-icons/fc';
import SectionButton from './components/SectionButton';
import SectionEmbed from './components/SectionEmbed';
import SectionLinks from './components/SectionLinks';
import SectionQRCode from './components/SectionQRCode';

interface ISectionShareProps {
	service: IEventType;
	onChange: (values: Partial<IEventType>) => void;
}
export default function SectionShare(props: ISectionShareProps) {
	const { t } = useTranslation();

	return (
		<Details image={<FcShare />} title={t('Share booking calendar')}>
			<Accordion allowToggle>
				<SectionButton url={window.location.origin + ROUTE_BOOKING_PAGE.replace(':id', props.service.id)} />
				<SectionEmbed url={window.location.origin + ROUTE_BOOKING_PAGE.replace(':id', props.service.id)} />
				<SectionLinks
					customLink={window.location.origin + ROUTE_BOOKING_PAGE.replace(':id', props.service.fullSlug)}
					permanentLink={window.location.origin + ROUTE_BOOKING_PAGE.replace(':id', props.service.id)}
				/>
				<SectionQRCode
					customLink={window.location.origin + ROUTE_BOOKING_PAGE.replace(':id', props.service.fullSlug)}
					permanentLink={window.location.origin + ROUTE_BOOKING_PAGE.replace(':id', props.service.id)}
				/>
			</Accordion>
		</Details>
	);
}
